/**
 * @param serviceManager
 * @param classToInvoke
 * @returns {function(...[any]): any}
 * @constructor
 */
export function Resolver(classToInvoke, methodToInvoke = "invoke") {
    return (serviceManager) => {
        return function resolveViaClass(...args) {
            return serviceManager.get(classToInvoke)[methodToInvoke](...args);
        };
    };
}
